import _slicedToArray from 'babel-runtime/helpers/slicedToArray';
import React, { useState } from 'react';
import PropTypes from 'prop-types';

import Modal from '../Modal/Modal';
import VisualizerEmailForm from './VisualizerEmailForm';
import VisualizerEmailSuccess from './VisualizerEmailSuccess';

var VisualizerEmailModal = function VisualizerEmailModal(_ref) {
  var active = _ref.active,
      closeModalFunc = _ref.closeModalFunc,
      selectedProducts = _ref.selectedProducts,
      relativeUrl = _ref.relativeUrl;

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      isFormSuccess = _useState2[0],
      setIsFormSuccess = _useState2[1];

  return React.createElement(
    Modal,
    { active: active, closeModalFunc: closeModalFunc },
    isFormSuccess ? React.createElement(VisualizerEmailSuccess, {
      relativeUrl: relativeUrl,
      closeModalFunc: closeModalFunc
    }) : React.createElement(VisualizerEmailForm, {
      selectedProducts: selectedProducts,
      relativeUrl: relativeUrl,
      setIsFormSuccess: setIsFormSuccess
    })
  );
};

VisualizerEmailModal.propTypes = {
  active: PropTypes.bool.isRequired,
  closeModalFunc: PropTypes.func.isRequired,
  selectedProducts: PropTypes.array.isRequired,
  relativeUrl: PropTypes.string.isRequired
};

export default VisualizerEmailModal;